export class Onboarding {
    addressLine1: String
    addressLine2: String
    contactNumber: String
    countryId: number = null
    createDate: Date = new Date()
    createdBy: String
    firstName: String
    id: number
    isDeleted: boolean = false;
    lastName: String
    noOfEmployees: number
    noOfLicensesReq: number
    officialEMail: String
    orgLogo: String
    orgWebsite: String
    organizationName: String
    planId: number = 1
    registrationNumber: number
    status: number = 1
    minimum: number
    maximum: number
    updateCount: number
    updateDate: String
    updatedBy: String
    zipCode: String
}
